<template>
  <div>
    <h4>希望条件もあわせて問い合わせるとき</h4>
    <p>{{ messageTarget }}</p>
    <p>
      掲載中の求人情報に、たいへん興味を持っております。<br />
      是非一度、お話をお伺いする機会をいただければと思っております。<br />
      また、希望条件を以下にお伝えいたしますので、その他求人情報をご紹介いただけると光栄です。<br />
      <br />
      第１希望勤務地：○○○○<br />
      第２希望勤務地：○○○○<br />
      第１希望業種：調剤薬局<br />
      第２希望業種：調剤+OTC販売<br />
      希望雇用形態：正社員・派遣<br />
      希望給与：年収　○○○万円（月収○○万円）<br />
      希望連絡手段：携帯電話（090-XXXX-XXXX）<br />
      希望連絡時間帯：平日XX：XX～XX：XX、土日XX：XX～XX：XX
    </p>

    <h4>希望連絡手段を指定して問い合わせをするとき（電話）</h4>
    <p>{{ messageTarget }}</p>
    <p>
      掲載中の求人内容を拝見し、たいへん興味をもっております。<br />
      是非一度、お話をお伺いする機会をいただければと思っております。<br />
      尚、現在離職中のため、希望の勤務先があれば直ぐにでも
      検討したいと考えておりますので<br />
      以下携帯までご連絡をいただければ幸甚です。<br />
      <br />
      携帯電話番号：090-XXXX-XXXX<br />
      希望連絡時間帯：平日XX：XX～XX：XX、土日XX：XX～XX：XX
    </p>

    <h4>メールでの連絡を希望するとき（メール）</h4>
    <p>{{ messageTarget }}</p>
    <p>
      掲載中の求人内容を拝見し、たいへん興味をもっております。<br />
      是非一度、お話をお伺いする機会をいただければと思っております。<br />
      尚、現在就業中のため、日中は電話でのご連絡が難しく、メールにてご連絡をいただければ幸甚です。
      また、詳細につきましては以下の希望時間帯にてご連絡を頂けますよう、お願いいたします。<br />
      <br />
      携帯電話番号：090-XXXX-XXXX<br />
      希望連絡時間帯：平日XX：XX～XX：XX、土日XX：XX～XX：XX
    </p>
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  company: {
    type: Object,
    required: true
  }
});

const messageTarget = computed(() =>
  props.company.is_direct_application_plan
    ? '（採用法人名）採用ご担当者様'
    : '（薬剤師転職コンサルタント名）様'
);
</script>

<style>
p {
  font-size: 14px;
}
</style>
